// English language pack
export default {
  nav: {
    home: 'Home',
    allProducts: 'All Products',
    myOrder: 'My Orders',
    myEvaluate: 'My Reviews',
    shoppingCart: 'Cart',
    shops: 'Shops',
    serviceNumber: 'Service Number',
    aboutUs: 'About Us',
    contact: 'Contact'
  },
  common: {
    search: 'Search',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    price: 'Price',
    sales: 'Sales',
    default: 'Default',
    loading: 'Loading...',
    noData: 'No Data',
    noProducts: 'No Products',
    sort: 'Sort:',
    selectAll: 'Select all',
    quantity: 'Quantity',
    unitPrice: 'Unit price',
    operate: 'Operate',
    viewDetails: 'View details',
    enterContent: 'Please enter content',
    getCodeSuccess: 'Send Success',
    detail: 'detail',
    submitOrder: 'Submit',
    addShoppingCart: 'Add To Cart',
    buyNow: 'Buy',
    addSuccess: 'Success'
  },
  category: {
    allResults: 'All Results',
    sort: 'Sort:',
    default: 'Default',
    price: 'Price',
    sales: 'Sales',
    noProducts: 'No products in this category~'
  },
  evaluate: {
    myEvaluate: 'My Reviews',
    additionalEvaluate: 'Additional Review',
    fillProductEvaluate: 'Fill in product review:',
    initialEvaluate: 'Initial Review',
    additionalEvaluateLabel: 'Additional Review',
    enterYourComment: 'Please enter your comment',
    totalImages: 'Total',
    imagesUnit: ' images, you can upload ',
    moreImagesUnit: ' more',
    submitEvaluate: 'Submit Review',
    evaluateSubmitSuccess: 'Your review has been successfully submitted',
    buyAgain: 'Buy Again',
    backToHome: 'Back to Home',
    contentCannotBeEmpty: 'Content cannot be empty',
    additionalEvaluateSuccess: 'Additional review successful',
    myOrders: 'My Orders',
    evaluate: 'Evaluate',
    satisfaction: 'Product Satisfaction Rating',
    impression: 'Product Impression',
    review: 'Review',
    inputReview: 'Please enter your review',
    uploadCount: 'Total',
    pictures: 'pictures, you can upload',
    morePictures: 'more',
    submit: 'Submit Review',
    cannotEvaluate: 'Product cannot be evaluated or already evaluated!',
    successTitle: 'Your review has been submitted successfully'
  },
  user: {
    login: 'Login',
    loginSuccess: 'loginSuccess',
    register: 'Register',
    logout: 'Logout',
    account: 'Account',
    password: 'Password',
    myAccount: 'My Account',
    loginAccount: 'Login Account',
    confirmLogout: 'Are you sure to log out?',
    couponPackage: 'Coupon Package',
    shippingAddress: 'Shipping Address',
    membershipGrowth: 'Membership Growth Value',
    viewAll: 'View All',
    loginToViewProducts: 'Login to view products',
    firstUse: 'First use of GuoCao Mall?',
    enterPhone: 'Please enter your mobile phone number',
    enterEmail: 'Please enter your email address',
    phoneLogin: 'Phone Login',
    emailLogin: 'Email Login',
    enterCode: 'Please enter the verification code',
    getCode: 'Obtain verification code',
    getCodeShort: 'Get Code',
    rememberMe: 'Free login within seven days',
    loginNow: 'Login Now',
    haveAccount: 'Do you already have an account?',
    agreement: 'Agreement',
    nickname: 'Nickname',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    birthDate: 'Date of Birth',
    selectDate: 'Select',
    boundPhone: 'Bound phone number',
    changePhone: 'Change phone number',
    replace: 'Replace',
    securityTips: 'Security Tips',
    phoneSecurity: 'Binding your phone can improve account security',
    onePhone: 'One phone number can only be linked to one account',
    retrieve: 'retrieve',
    serviceAgreement: 'Service Agreement',
    confirmServiceAgreement: 'Please read and agree to the service agreement'
  },
  order: {
    orderNumber: 'Order No.',
    product: 'Product',
    unitPrice: 'Unit Price',
    quantity: 'Quantity',
    actualPayment: 'Payment',
    recipient: 'Recipient',
    status: 'Status',
    afterSaleOrders: 'After-sale Orders',
    operation: 'Operation',
    allOrders: 'All Orders',
    waitPay: 'Waiting payment',
    waitShip: 'Waiting shipment',
    waitReceive: 'Waiting receipt',
    waitEvaluate: 'Waiting evaluation',
    waitGroup: 'Waiting group buying',
    amountPaid: 'Amount of be paid',
    includingShipping: 'Including shipping costs',
    state: 'State',
    completed: 'Completed',
    shopName: 'Shop name',
    orderId: 'Order ID',
    specification: '1ml/bottle',
    orderDetails: 'Order details',
    buyAgain: 'Buy again',
    returnGoods: 'Return',
    refund: 'Refund',
    evaluate: 'Evaluate',
    submitOrder: 'Submit',
    processOrder: 'Process',
    outbound: 'Outbound',
    delivery: 'Delivery',
    deliveryInfo: 'Delivery Information',
    deliveryAddress: 'Delivery address',
    recipientPhone: 'Recipient phone number',
    sellerInfo: 'Seller Information',
    phoneNumber: 'Phone number',
    orderInfo: 'Order information',
    trackingNumber: 'Tracking number',
    logisticsCompany: 'Logistics company',
    creationTime: 'Creation time',
    notes: 'Notes',
    productAttr: 'Unit',
    closed: 'Closed',
    totalPrice: 'Total price of the items',
    freight: 'Transportation costs',
    discounts: 'Discounts',
    paymentAmount: 'Payment Amount',
    logisticsInfo: 'Logistics information',
    deliveryMethod: 'Delivery method',
    express: 'Express delivery',
    waybill: 'Tracking number',
    logisticsTracking: 'Logistics tracking',
    groupInfo: 'Group Buying Information',
    waitForGroup: 'Payment successful, waiting for group completion',
    groupSuccess: 'Congratulations! Group buying successful',
    groupFailed: 'Group buying failed due to time limit',
    personGroup: 'person group, still need',
    person: 'person(s)',
    refundAfterFail: 'After group buying fails, the paid amount will be refunded!',
    remainingTime: 'Remaining time',
    hour: 'h',
    minute: 'm',
    second: 's',
    groupLeader: 'Group Leader',
    rejectReason: 'Rejection Reason',
    applyPlatformIntervention: 'Apply for Platform Intervention',
    confirmCancelPay: 'Confirm to cancel payment?',
    wechatPay: 'Please scan with WeChat to pay ￥',
    inviteFriends: 'Invite Friends',
    scanQRCode: 'Scan the QR code below or copy the link to share with friends',
    copy: 'Copy'
  },
  cart: {
    allProducts: 'All Products',
    selectAll: 'Select All',
    productName: 'Product Name',
    productAttr: 'Product Attributes',
    subtotal: 'Subtotal',
    operation: 'Operation',
    empty: 'No product in the cart, Please make your purchase.',
    settlement: 'Checkout',
    totalNotIncludeFreight: 'Total (excluding freight)',
    coupon: 'Coupon',
    emptyCart: 'No result in the cart~',
    pleaseLogin: 'Please Login',
    viewAfterLogin: 'View products after logging in',
    deleteSelected: 'Delete Selected',
    clearInvalid: 'Clear Invalid Items',
    selectedCount: 'Selected Items',
    piece: 'piece',
    total: 'Total (excluding shipping)',
    checkout: 'Checkout',
    invalidSelection: 'Please select at least one item',
    outOfStock: 'Some selected items are out of stock',
    deleteSuccess: 'Deleted successfully',
    clearSuccess: 'Cleared successfully!',
    clearFailure: 'Failed to clear!',
    goToStore: 'Go to Store',
    promotionalActivities: 'Promotional Activities',
    bundledPricing: 'Bundled Pricing',
    activityTypes: {
      type1: 'Buy More Save More',
      type2: 'Buy More Get Discount',
      type3: 'Buy More Special Offer',
      fixedPrice: 'Fixed Price',
      discount: 'Discount',
      fullReduction: 'Full Reduction'
    },
    coupons: {
      platformCoupon: 'Platform Coupon',
      merchantCoupon: 'Merchant Coupon',
      receiveSuccess: 'Received successfully!',
      receiveFailure: 'Failed to receive!'
    },
    noItemsInCart: 'Your shopping cart is empty!',
    removeCartItem: 'Are you sure you want to delete this item?',
    confirmDelete: 'Confirm',
    cancelDelete: 'Cancel',
    deleteConfirmation: 'After deletion, the item will no longer be in the shopping cart. Are you sure you want to delete it?',
  },
  userCenter: {
    userInfoFailed: 'Failed to get user info!',
    deleteSuccess: 'Delete successful',
    loginRequired: 'User not logged in',
    orderCancelSuccess: 'Order canceled successfully',
    orderDeleteSuccess: 'Order deleted successfully',
    confirmReceiveSuccess: 'Goods received successfully',
    regularMember: 'Regular member',
    myMessage: 'My message',
    orderReceived: 'The order xxx has been received and we look forward to your feedback',
    orderShipped: 'The Order xxx you purchased has been shipped by the merchant, Click to view logistics details.',
    orderPaid: 'The Order xxx you purchased has been paid, please wait for the merchant to ship it.',
    orderClosed: 'You did not complete the payment within the specified time. Order xxx has been closed. Click to view details.',
    personalInfo: 'Personal Information',
    myQa: 'My Q&A',
    myQuestions: 'Questions',
    myAnswers: 'Answers',
    noQuestions: 'You haven\'t asked any questions yet',
    noAnswers: 'You haven\'t answered yet',
    batchManage: 'Batch management',
    afterSaleProcessing: 'In the processing',
    afterSaleCompleted: 'Completed',
    refundAmount: 'Refund amount',
    applyTime: 'Application Time',
    toBeReviewed: 'To be reviwed',
    supplementary: 'Supplementary',
    reviewed: 'Completed',
    searchReview: 'Please enter the product name or order number',
    fillReview: 'Fill in product reviews',
    satisfaction: 'Satisfaction rating',
    impression: 'Impression',
    cheapFine: 'Cheap and fine',
    fastDelivery: 'Delivery fast',
    worthBuying: 'Worth buying',
    general: 'General',
    acceptable: 'Acceptable',
    badReview: 'Bad',
    comment: 'Comment',
    enterComment: 'Please enter your comment',
    uploadImage: 'There are 0 sheets in total, and you can upload 5 more sheets',
    submitReview: 'Submit',
    reviewNotEmpty: 'The review content can not be empty',
    addAddress: 'Add new address',
    defaultAddress: 'Set as default',
    myFavorite: 'My Favorite',
    favoriteProducts: 'Favorite Products',
    favoriteShops: 'Favorite Shops',
    cancelFavorite: 'Cancel',
    browsingHistory: 'Browsing History',
    myVouchers: 'My Vouchers',
    notUsed: 'Not used',
    used: 'Used',
    invalid: 'Invalid',
    authentication: 'Authentication',
    nextStep: 'Next',
    enterNewNumber: 'Enter the new number',
    enterNickname: 'Enter the nickname',
    enterBirthday: 'Enter the birthday',
    modifySuccess: 'Modify successful!',
    uploadSuccess: 'Upload successful, please save!',
    submit: 'Submit'
  },
  product: {
    productZone: 'XXX Zone',
    sold: 'Sold',
    favorite: 'Favorite',
    discounts: 'Discounts',
    defaultSpec: 'Default specifications',
    inventory: 'Inventory',
    removed: 'Removed',
    guessLike: 'Guess you like',
    productDetail: 'Details',
    productComment: 'Comment',
    productQa: 'Q&A',
    items: 'items',
    qaTitle: 'Have any questions? Ask students who have bought this product~',
    askQuestion: 'Ask Question',
    question: 'Q',
    answer: 'A',
    noAnswer: 'No answers yet',
    showMore: 'Show more replies',
    hideAnswers: 'Hide answers',
    iWantToAnswer: 'I want to answer',
    askQuestionTitle: 'Ask Question',
    answerTitle: 'Answer',
    questionTip: 'Your question will be pushed to users who have purchased, and they will help you answer~',
    questionPrefix: 'Q: ',
    enterContent: 'Please enter content',
    anonymousQuestion: 'Anonymous question',
    anonymousAnswer: 'Anonymous answer',
    cancel: 'Cancel',
    publish: 'Publish',
    enterQuestionContent: 'Please enter question content',
    enterAnswerContent: 'Please enter answer content',
    questionSuccess: 'Question submitted successfully',
    answerSuccess: 'Answer submitted successfully',
    evaluation: {
      all: 'All',
      additionalComment: '{Additional Comment}',
      confirmReceiptAfter: 'Added after confirming receipt for ',
      daysAdditional: ' days',
      noComments: 'No comment information~~'
    },
  },
  store: {
    storeHome: 'Store Home',
    info: 'Store Information',
    collect: 'Collect',
    service: 'WeChat Service',
    location: 'Location',
    enter: 'Enter Store',
    search: 'Enter product name'
  },
  afterSale: {
    apply: 'Apply for After-sale',
    process: 'Order Processing',
    returning: 'Returning',
    completed: 'Completed',
    refundAmount: 'Refund Amount',
    applyTime: 'Application Time',
    code: 'After-sale No.',
    reviewing: 'Under Review',
    refunding: 'Refunding',
    refundSuccess: 'Refund Successful',
    refundFailed: 'Refund Failed',
    reviewFailed: 'Review Failed',
    evaluating: 'Evaluating',
    returnCompleteRefundRejected: 'Return Complete, Refund Rejected',
    reviewPassed: 'Review Passed',
    details: 'After-sale Details',
    platformIntervention: 'Apply for Platform Intervention',
    noOrders: 'You don\'t have any after-sale orders yet~',
    interventionSuccess: 'Platform intervention application successful',
    sellerInfo: 'Seller Information',
    shopName: 'Shop Name',
    contactPhone: 'Contact Phone',
    orderInfo: 'Order Information',
    orderNumber: 'Order No.',
    paymentChannel: 'Payment Channel',
    transactionId: 'Transaction ID',
    creationTime: 'Creation Time',
    paymentTime: 'Payment Time',
    transactionTime: 'Transaction Time',
    product: 'Product',
    productAttributes: 'Product Attributes',
    status: 'Status',
    quantity: 'Quantity',
    unitPrice: 'Unit Price',
    waitingPayment: 'Waiting Payment',
    waitingShipment: 'Waiting Shipment',
    waitingReceipt: 'Waiting Receipt',
    closed: 'Closed',
    afterSaleNumber: 'After-sale No.',
    afterSaleDetails: 'After-sale Details',
    applyAfterSale: 'Apply After-sale',
    afterSaleMethod: 'After-sale Method',
    selectAfterSaleMethod: 'Please select after-sale method',
    refundOnly: 'Refund Only',
    returnAndRefund: 'Return and Refund',
    goodsStatus: 'Goods Status',
    selectGoodsStatus: 'Please select goods status',
    receivedGoods: 'Received Goods',
    notReceivedGoods: 'Not Received Goods',
    afterSaleReason: 'After-sale Reason',
    selectAfterSaleReason: 'Please select after-sale reason',
    reasonDescription: 'Reason Description',
    enterReturnReason: 'Enter return reason description',
    uploadProof: 'Upload Proof',
    maxUpload3Images: 'Max 3 images',
    submitApplication: 'Submit Application',
    revokeApplication: 'Revoke Application',
    revokeReturn: 'Revoke Return',
    contactMerchant: 'If you have any questions, please contact the merchant',
    rejectReason: 'Reject Reason',
    revokeApplicationSuccess: 'Revoke application successful',
    revokeReturnSuccess: 'Revoke return successful',
    afterSaleApplicationSuccess: 'After-sale application successful',
    selectAfterSaleMethodError: 'Please select after-sale method',
    selectGoodsStatusError: 'Please select goods status',
    selectAfterSaleReasonError: 'Please select after-sale reason'
  },
  search: {
    productName: 'Product',
    shop: 'Shop',
    placeholder: 'Please enter search product',
    enterContent: 'Please enter search content',
    search: {
      allResults: 'All Results',
      sort: 'Sort',
      default: 'Default',
      price: 'Price',
      sales: 'Sales',
      confirm: 'Confirm',
      clear: 'Clear',
      noProduct: 'No products found. Try different keywords.',
      noShop: 'No shops found. Try different keywords.',
      networkError: 'Network error. Please try again.',
      location: 'Location'
    },
    product: {
      allProducts: 'All Products',
      productName: 'Product Name',
      productAttributes: 'Product Attributes',
      unitPrice: 'Unit Price',
      quantity: 'Quantity',
      subtotal: 'Subtotal',
      operation: 'Operation',
      discontinued: 'Discontinued',
      coupon: 'Coupon',
      availableCoupons: 'Available Coupons:',
      platformCoupon: 'Platform Coupon',
      merchantCoupon: 'Merchant Coupon',
      delete: 'Delete',
      clearInvalid: 'Clear Invalid Items',
      selectedItems: 'Selected Items',
      items: 'items',
      total: 'Total (Excluding Shipping)',
      couponDiscount: 'Coupon Discount',
      checkout: 'Checkout',
      emptyCart: 'Your shopping cart is empty',
      activityName: 'Activity Discount',
      meet: 'Meet',
      price: 'price',
      storeName: 'Store'
    },
    express: {
      shippingInfo: 'Shipping Information',
      returnShippingInfo: 'Return Shipping Information',
      shippingAddress: 'Shipping Address',
      returnShippingAddress: 'Return Shipping Address',
      recipient: 'Recipient',
      returnRecipient: 'Return Recipient',
      phone: 'Phone',
      returnPhone: 'Return Phone',
      sellerInfo: 'Seller Information',
      storeName: 'Store Name',
      contactPhone: 'Contact Phone'
    },
    allResults: 'All Results',
    sort: 'Sort',
    default: 'Default',
    price: 'Price',
    sales: 'Sales',
    confirm: 'Confirm',
    clear: 'Clear',
    noProduct: 'No products found. Try different keywords.',
    noShop: 'No shops found. Try different keywords.',
    networkError: 'Network error. Please try again.',
    location: 'Location'
  },
  orderDetail: {
    orderNumber: 'Order No.',
    remainingTime: 'Remaining Time',
    cancelOrder: 'Cancel Order',
    payment: 'Payment',
    inviteFriends: 'Invite Friends',
    openNewGroup: 'Start New Group',
    revokeApplication: 'Revoke Application',
    deliveryInfo: 'Delivery Information',
    returnAddress: 'Return Address',
    returnRecipient: 'Return Recipient',
    returnPhone: 'Return Phone',
    sellerInfo: 'Seller Information',
    shopName: 'Shop Name',
    contactPhone: 'Contact Phone',
    orderInfo: 'Order Information',
    trackingNumber: 'Tracking Number',
    logisticsCompany: 'Logistics Company',
    creationTime: 'Creation Time',
    remarks: 'Remarks',
    orderStatus: 'Order Status',
    waitingPayment: 'Waiting Payment',
    waitingShipment: 'Waiting Shipment',
    waitingReceipt: 'Waiting Receipt',
    completed: 'Completed',
    closed: 'Closed',
    submitOrder: 'Submit Order',
    orderProcessing: 'Order Processing',
    productOutbound: 'Product Outbound',
    waitingDelivery: 'Waiting Delivery',
    groupBuying: 'Group Buying',
    groupFailed: 'Group Failed',
    shipping: 'Shipping',
    applyAfterSale: 'Apply After Sale',
    enterReturnLogistics: 'Enter Return Logistics',
    auditPassed: 'Audit Passed',
    auditFailed: 'Audit Failed',
    refundFailed: 'Refund Failed',
    paymentSuccessful: 'Payment Successful',
    afterSaleMethod: 'After-sale Method',
    selectAfterSaleMethod: 'Please select after-sale method',
    goodsStatus: 'Goods Status',
    selectGoodsStatus: 'Please select goods status',
    afterSaleReason: 'After-sale Reason',
    selectAfterSaleReason: 'Please select after-sale reason',
    reasonDescription: 'Reason Description',
    enterReturnReason: 'Enter return reason description',
    afterSaleInfo: 'After-sale Information',
    refundOnly: 'Refund Only',
    returnAndRefund: 'Return and Refund',
    notReceived: 'Not Received',
    received: 'Received',
    returnReasonDescription: 'Return Reason Description',
    evidence: 'Evidence',
    returnLogistics: 'Return Logistics',
    logisticsCompanySelect: 'Please select logistics company (searchable)',
    enterTrackingNumber: 'Please enter tracking number',
    confirmSubmit: 'Confirm Submit',
    totalPrice: 'Total Price',
    shippingFee: 'Shipping Fee',
    platformDiscount: 'Platform Discount',
    merchantDiscount: 'Merchant Discount',
    amountToPay: 'Amount to Pay',
    refundAmount: 'Refund Amount'
  },
  coupon: {
    platformCoupon: 'Platform Coupon',
    shopCoupon: 'Shop Coupon',
    usageCondition: 'Usage Condition: Min ',
    validPeriod: 'Valid Period: ',
    limitedToShop: 'Limited to shop use',
  },
  placeOrder: {
    selectShippingAddress: 'Please select shipping address',
    addNewAddress: 'Add new address',
    noShippingInfo: 'No shipping information',
    recipientInfo: 'Recipient Information:',
    changeAddress: 'Change address',
    shop: 'Shop: ',
    product: 'Product',
    productAttributes: 'Product Attributes',
    unitPrice: 'Unit Price',
    quantity: 'Quantity',
    discountMethod: 'Discount Method',
    subtotal: 'Subtotal',
    groupBuy: 'Group Buy',
    flashSale: 'Flash Sale',
    discount: 'Discount',
    fixedPriceBundle: 'Fixed Price Bundle',
    combinationBundle: 'Combination Bundle',
    sceneMarketing: 'Scene Marketing',
    memberPrice: 'Member Price',
    none: 'None',
    addressNotSupported: 'Current address does not support delivery, please try another address',
    remarksPlaceholder: 'If you have other requirements, please leave a note.',
    shipping: 'Shipping: ',
    shopTotal: 'Shop Total: ',
    selectPaymentMethod: 'Please select payment method',
    wechatPay: 'WeChat Pay',
    alipay: 'Alipay',
    submitOrder: 'Submit Order',
    totalPrice: 'Total: ',
    couponDiscount: 'Discount: ',
    amountPayable: 'Amount Payable: ',
    pleaseSelectPaymentMethod: 'Please select payment method',
    pleaseSelectShippingAddress: 'Please select your shipping address',
    addressNotSupportedTip: 'Current address does not support delivery, please refer to the red text prompt!',
    paymentSuccess: 'Payment successful!',
    paymentFailed: 'Payment failed!',
    paymentCancelled: 'Payment cancelled!',
    modifyShippingAddress: 'Modify shipping address',
    addShippingAddress: 'Add shipping address',
    couponDiscountExceedsTotal: 'Coupon discount amount cannot be greater than or equal to the total amount!',
    cannotCombineWithMerchantCoupon: 'Cannot be used with merchant coupons!',
    couponConditionsNotMet: 'Coupon usage conditions not met!',
    cannotUseExceedingCoupon: 'Cannot use coupons with value greater than or equal to the total amount!',
    confirmOrderInfo: 'Confirm order information',
    wechatPayment: 'WeChat Pay',
  },
  addAddress: {
    region: 'Region:',
    detailedAddress: 'Detailed Address:',
    recipientName: 'Recipient Name:',
    phoneNumber: 'Phone Number:',
    setAsDefault: 'Set as default shipping address',
    cancel: 'Cancel',
    confirm: 'Confirm',
    enterAddress: 'Please enter address',
    selectRegion: 'Please select region!',
    enterDetailedAddress: 'Please enter detailed address!',
    enterRecipientName: 'Please enter recipient name!',
    enterPhoneNumber: 'Please enter phone number!',
    invalidPhoneFormat: 'Invalid phone number format'
  },
  couponBox: {
    usageCondition: 'Usage Condition:',
    validPeriod: 'Valid Until:',
    platformCoupon: 'Platform Coupon',
    shopCoupon: 'Shop Coupon',
    use: 'Use Now',
    discount: 'Discount:',
    minSpend: 'Min ',
    yuan: 'yuan',
    discountPercent: 'off'
  }
}
export const lang = 'en'



// WEBPACK FOOTER //
// ./src/config/lang/en.js